import global from "@/locales/it-IT/global";
import error403 from "@/locales/it-IT/errors/403";
import error404 from "@/locales/it-IT/errors/404";
import error500 from "@/locales/it-IT/errors/500";
import error503 from "@/locales/it-IT/errors/503";
import error504 from "@/locales/it-IT/errors/504";
import maintenance from "@/locales/it-IT/auth/maintenance";
import toast from "@/locales/it-IT/toast/toast";
import login from "@/locales/it-IT/auth/login";
import onboarding from "@/locales/it-IT/auth/onboarding";
import loginPageSteps from "@/locales/it-IT/loginPageSteps";
import dashboard from "@/locales/it-IT/dashboard/dashboard";
import account from "@/locales/it-IT/account/account";
import mailbox from "@/locales/it-IT/account/mailbox";
import bankstatement from "@/locales/it-IT/account/bankstatement";
import myApps from "@/locales/it-IT/my-apps/myApps";
import about from "@/locales/it-IT/about/about";
import contactService from "@/locales/it-IT/about/contactService";
import salesPromotions from "@/locales/it-IT/sales/promotions";
import brochures from "@/locales/it-IT/sales/brochures";
import shop from "@/locales/it-IT/shop/data";
import priceList from "@/locales/it-IT/shop/priceList";
import staff from "@/locales/it-IT/dashboard/staff";
import promotions from "@/locales/it-IT/promotions";
import points from "@/locales/it-IT/points";
import trainings from "@/locales/it-IT/trainings/trainings";
import vouchers from "@/locales/it-IT/vouchers/vouchers";
import media from "@/locales/it-IT/media/index";
import product from "@/locales/it-IT/product/index";
import message from "@/locales/it-IT/message/index";
import commitmentLetter from "@/locales/it-IT/account/commitmentLetter";
import multiplicator from "@/locales/it-IT/multiplicator";
import widgets from "@/locales/it-IT/widgets/widgets";
import consents from "@/locales/it-IT/consents/consents";
import investment from "@/locales/it-IT/investment/data";
import kickback from "@/locales/it-IT/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Immagini dei prodotti",
    BDriveLinkText: "Link al portale IMMAGINI PRODOTTI",
  },
}

export default {
  locale: "it-IT",
  messages,
};
